import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import './Schedule.css';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import posterEven from '../../../assets/schedule/SNN 2026-POSTER CODE-EVEN.pdf';
import posterOdd from '../../../assets/schedule/SNN 2026-POSTER CODE-ODD.pdf';

const API_BASE = 'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion';

export const ScheduleEventCard = ({ event }) => (
  <div className="schedule-event-card">
    <p className="schedule-event-time">{event.time}</p>
    <div>
      {event.code && <span className="schedule-event-code">{event.code}</span>}
      {event.title && <p className="schedule-event-title">{event.title}</p>}
      {event.speaker && <p className="schedule-event-speaker">{event.speaker}</p>}
      {event.location && (
        <p className="schedule-event-location">
          <span className="material-symbols-outlined">location_on</span>
          {event.location}
        </p>
      )}
    </div>
  </div>
);

ScheduleEventCard.propTypes = {
  event: PropTypes.shape({
    time: PropTypes.string,
    code: PropTypes.string,
    title: PropTypes.string,
    speaker: PropTypes.string,
    location: PropTypes.string,
  }).isRequired,
};

export const ScheduleDayTabs = ({ days, activeIndex, onSelect }) => (
  <div className="schedule-days-tabs">
    {days.map((day, di) => (
      <button
        key={di}
        type="button"
        onClick={() => onSelect(di)}
        className={`schedule-day-tab ${di === activeIndex ? 'active' : ''}`}
      >
        <span className="schedule-day-tab-label">{day.dayLabel}</span>
        <span className="schedule-day-tab-date">{day.date}</span>
      </button>
    ))}
  </div>
);

ScheduleDayTabs.propTypes = {
  days: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export const Schedule = () => {
  const [schedule, setSchedule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeDay, setActiveDay] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE}`)
      .then((res) => res.json())
      .then((data) => {
        setSchedule(data.schedule);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const days = schedule?.days || [];
  const currentDay = days[activeDay];

  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h2 className="snn-title">{schedule?.title || 'Program'}</h2>

          {loading && <p className="schedule-empty">Loading schedule...</p>}

          {!loading && !schedule && (
            <p className="schedule-empty">The program will be available soon.</p>
          )}

          <div className="schedule-links-wrapper">
            <a href={posterEven} download="SNN 2026-POSTER CODE-EVEN.pdf">
              <span className="material-symbols-outlined">download</span>
              Poster Code – Even
            </a>
            <a href={posterOdd} download="SNN 2026-POSTER CODE-ODD.pdf">
              <span className="material-symbols-outlined">download</span>
              Poster Code – Odd
            </a>
          </div>

          {!loading && schedule && (
            <>
              {schedule.download_links && schedule.download_links.length > 0 && (
                <div className="schedule-links-wrapper">
                  {schedule.download_links.map((link, i) => (
                    <a key={i} href={link.url} target="_blank" rel="noreferrer">
                      <span className="material-symbols-outlined">download</span>
                      {link.label}
                    </a>
                  ))}
                </div>
              )}

              {days.length > 0 && (
                <>
                  <ScheduleDayTabs
                    days={days}
                    activeIndex={activeDay}
                    onSelect={setActiveDay}
                  />

                  {currentDay && currentDay.events && currentDay.events.length > 0 ? (
                    <div className="schedule-events-list">
                      {currentDay.events.map((ev, ei) => (
                        <ScheduleEventCard key={ei} event={ev} />
                      ))}
                    </div>
                  ) : (
                    <p className="schedule-empty">No events scheduled for this day yet.</p>
                  )}
                </>
              )}
            </>
          )}
        </section>
      </div>
      <Footer />
    </>
  );
};
